
import { defineComponent, PropType } from "vue";
import EventBusService from "@/services/EventBusService";
import { RecordIdentifier } from "@/data/global";
import { Region } from "@/data/region";
import RegionProducts from "@/components/RegionProducts.vue";

declare interface RegionProductsModalData {
    loading: boolean,
    shownLocal: boolean,
}

export default defineComponent({
    name: 'RegionProductsModal',
    components: {
        RegionProducts,
    },
    emits: [
        'close',
    ],
    props: {
        region: {
            type: [Object, Number] as PropType<Region|RecordIdentifier|null>,
            required: false,
            default: null,
        },
        shown: {
            type: Boolean,
            required: true,
        },
    },
    data(): RegionProductsModalData {
        return {
            loading: false,
            shownLocal: true,
        };
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
        onUserCreditChanged() {
            this.closeModal();
        },
    },
    watch: {
        shown: {
            handler(val) {
                this.shownLocal = val;
            },
            immediate: true,
        },
    },
    mounted() {
        /*this.$watch('shown', (newShown: boolean) => {
            if( newShown ) {
                console.log('tmp SHOW MODAL RegionProductsModal');
            }
        });*/
        EventBusService.$on('user.credits:changed', this.onUserCreditChanged);
    },
    beforeUnmount() {
        EventBusService.$off('user.credits:changed', this.onUserCreditChanged);
    }
});
